import { FC } from "react";
import { useIntl } from "react-intl";
import { DealWinner } from '../apps/core/_models'

interface BadgeStatusProps {
  status: string;
  winner?: DealWinner | null;
}

export const BadgeStatusDeal: FC<BadgeStatusProps> = ({ status, winner }) => {
  const intl = useIntl();

  const getBadgeClass = (state: string) => {
    switch (state) {
      case "new":
        return "badge-light-primary";
      case "canceled":
        return "badge-light-danger";
      case "running":
        return "badge-light-warning";
      case "completed":
        if (winner === "seller" || winner === "both") {
          return "badge-light-success";
        }
        if (winner === "buyer") {
          return "badge-light-danger";
        }
        return "badge-light-success";
      default:
        return "";
    }
  };

  const getBadgeText = (state: string) => {
    switch (state) {
      case "new":
        return intl.formatMessage({ id: "DEAL.STATE.NEW" });
      case "canceled":
        return intl.formatMessage({ id: "DEAL.STATE.CANCELED" });
      case "running":
        return intl.formatMessage({ id: "DEAL.STATE.RUNNING" });
      case "completed":
        if (winner === "seller" || winner === "both") {
          return intl.formatMessage({ id: "DEAL.STATE.SUCCESS" });
        }
        if (winner === "buyer") {
          return intl.formatMessage({ id: "DEAL.STATE.UNSUCCESSFUL" });
        }
        return intl.formatMessage({ id: "DEAL.STATE.COMPLETED" });
      default:
        return "";
    }
  };

  return (
    <span className={`badge py-3 px-4 fs-8 fs-sm-7 ${getBadgeClass(status)}`}>
      {getBadgeText(status)}
    </span>
  );
};
